var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.248 2.517c.689.689.689 1.806 0 2.496l-5.223 5.222h12.21a1.765 1.765 0 0 1 0 3.53H8.025l5.223 5.223a1.765 1.765 0 1 1-2.496 2.495l-8.235-8.235a1.765 1.765 0 0 1 0-2.496l8.235-8.235c.69-.69 1.807-.69 2.496 0",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeft;